import styled from 'styled-components'

import { DASHBOARD_STYLED_CONSTS } from '@components/common/Dashboard/consts'
import { mediaQueries } from '@fourthwall/components'

export const Container = styled.ul`
  display: flex;
  flex-direction: column;

  ${mediaQueries.tablet} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: var(--space-400);
  }
`

export const ItemContainer = styled.li`
  position: relative;
  left: -${DASHBOARD_STYLED_CONSTS.CONTENT_PADDING_HORIZONTAL}px;
  width: calc(100% + ${DASHBOARD_STYLED_CONSTS.CONTENT_PADDING_HORIZONTAL * 2}px);
  border-top: 1px solid var(--border-secondary);
  border-bottom: 1px solid var(--border-secondary);

  & + & {
    margin-top: -1px;
  }

  ${mediaQueries.tablet} {
    position: static;
    width: auto;
    border: 1px solid var(--border-secondary);
    border-radius: var(--radius-brand);

    transition: border-color var(--motion-duration-100) var(--motion-ease-in-out);

    & + & {
      margin-top: 0;
    }

    &:hover {
      border-color: var(--border-secondary-hover);
      z-index: 1;
    }
  }
`

export const ItemInner = styled.a`
  padding: var(--space-400);
  display: flex;
  flex-direction: row;
  text-align: left;
  gap: var(--space-300);

  ${mediaQueries.tablet} {
    padding: var(--space-500);
    gap: var(--space-400);
    align-items: stretch;
  }
`

export const ItemImageContainer = styled.div`
  height: 56px;
  aspect-ratio: 200 / 112;
  align-self: flex-start;

  ${mediaQueries.tablet} {
    width: 147px;
    height: 88px;
    aspect-ratio: 147/88;
    align-self: stretch;
  }
`

export const ItemImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--radius-brand);

  display: block;
`

export const ItemMain = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const Title = styled.div`
  font-family: var(--font-family-heading);
  font-size: var(--font-size-400);
  font-style: normal;
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-dense);
  text-wrap: balance;
`

export const Footer = styled.footer`
  margin-top: var(--space-200);

  ${mediaQueries.tablet} {
    display: flex;
    align-items: flex-end;
  }
`

export const TimeToRead = styled.div`
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-400);
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  gap: var(--space-100);

  ${mediaQueries.tablet} {
    flex: 1;
  }
`
